/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

import par from "par";

import defineUI from "../shared/define";
import render from "./render.jsx";
import PersonStore from "../stores/person_store";
import LocalizationStore from "../stores/localization_store";
import CurrentPersonInfoStore from "../stores/current_person_info_store";
import CareplanNotificationStore from "../stores/careplan_notice_store";
import ConnectionStore from "../stores/connection_store";
import StaffStore from "../stores/staff_store";
import WorkflowDefinitionsStore from "../stores/workflow_definitions_store.js";
import ManagerGroupsStore from "../stores/group_manager_groups_store";
import ManagerGroupsManagersStore from "../stores/group_manager_group_managers_store";
import UserFormsStore from "../stores/user_form_store";

import storeFactory from "../shared/stores";

var makeStores = storeFactory({
	people: PersonStore,
	workflows: WorkflowDefinitionsStore,
	currentPerson: CurrentPersonInfoStore,
	localization: LocalizationStore,
	connection: ConnectionStore,
	careplanChangeList: CareplanNotificationStore,
	staff: StaffStore,
	managergroups: ManagerGroupsStore,
	managergroupsmanagers: ManagerGroupsManagersStore,
	userForms: UserFormsStore
});

function make_ui(api, events, config, userMetrics) {
	var storeStore = makeStores(api, events, config);

	userMetrics.trackEvent("page view", {
		"page": "group-manage-groups",
		"category": "group",
		"permission level": "staff",
	});

	return defineUI({
		getInitialState: getInitialState,
		componentDidMount: listen_for_changes,
		render: render
	});

	function listen_for_changes() {
		storeStore.listen(par(handle_change, this));
	}

	function handle_change(component, stores) {
		component.setState({
			workflows: stores.workflows,
			currentPerson: stores.currentPerson,
			localization: stores.localization,
			people: stores.people,
			careplanChangeList: stores.careplanChangeList,
			connection: stores.connection,
			staff: stores.staff,
			managerGroups: stores.managergroups,
			managerGroupManagers: stores.managergroupsmanagers,
			userForms: stores.userForms.all(),
		});
	}

	function getInitialState() {
		return {
			currentPerson: storeStore.stores.currentPerson,
			localization: storeStore.stores.localization,
			people: storeStore.stores.people,
			connection: storeStore.stores.connection,
			workflows: storeStore.stores.workflows,
			careplanChangeList: storeStore.stores.careplanChangeList,
			staff: storeStore.stores.staff,
			managerGroups: storeStore.stores.managergroups,
			managerGroupManagers: storeStore.stores.managergroupsmanagers,
			viewing: null,
			creating: false,
			updating: false,
			adding: false,
			removing: false,
			locking: false,
			unlocking: false,
			removingManager: false,
			newName: null,
			newDescription: null,
			updateName: null,
			updateDescription: null,
			filteredManagers: null,
			filteredManagerGroups: null,
			create: createManagerGroup,
			remove: removeManagerGroup,
			update: updateManagerGroup,
			removeManager: removeManager,
			addManager: addManager,
			search: doSearch,
			updatePermissions: updatePermissions,
			lockGroup: lockGroup,
			unlockGroup: unlockGroup,
			permissionUpdates: {},
			userForms: [],
			message: false,
			currentPersonId: storeStore.stores.currentPerson.get("personal")._id,
			userMetrics: userMetrics,
		};
	}

	function updatePermissions(group, permissions){
		return api.org.managergroups.permissions(group, permissions);
	}


	function createManagerGroup(name, description){
		return api.org.managergroups.create(name, description);
	}

	function lockGroup (group){
		return api.org.managergroups.lock(group);
	}

	function unlockGroup (group){
		return api.org.managergroups.unlock(group);
	}

	function removeManagerGroup(group){
		return api.org.managergroups.remove(group);
	}

	function updateManagerGroup(group, name, description){
		return api.org.managergroups.update(group, name, description);
	}

	function removeManager(group, member){
		return api.org.managergroups.managers.remove(group, member);
	}

	function addManager(group, member){
		return api.org.managergroups.managers.add(group, member);
	}

	function doSearch(query) {
		var filter = {
			type: {
				exclude: ["atouchaway", "user:mobile", "simplified"]
			}
		};

		return api.people.search(query, filter);
	}
}


export default make_ui;
